import {
  Activity, Cog, Wind, Gauge, Wrench, Zap, Disc3, Car, Truck, BatteryCharging,
  Fuel, Thermometer, Droplets, Snowflake, Lightbulb, Radio, Settings, ShieldCheck,
  Sparkles, Hammer, Flame,
} from "lucide-react";

export const SERVICE_ICONS = {
  wrench: Wrench,
  activity: Activity,
  cog: Cog,
  wind: Wind,
  gauge: Gauge,
  disc: Disc3,
  zap: Zap,
  car: Car,
  truck: Truck,
  battery: BatteryCharging,
  fuel: Fuel,
  thermometer: Thermometer,
  droplets: Droplets,
  snowflake: Snowflake,
  lightbulb: Lightbulb,
  radio: Radio,
  settings: Settings,
  shield: ShieldCheck,
  sparkles: Sparkles,
  hammer: Hammer,
  flame: Flame,
};

export const ICON_KEYS = Object.keys(SERVICE_ICONS);

export const ICON_LABELS = {
  wrench: "Apkope",
  activity: "Diagnostika",
  cog: "Dzinējs",
  wind: "Turbo",
  gauge: "Ātrumkārba",
  disc: "Bremzes",
  zap: "Elektrika",
  car: "Virsbūve",
  truck: "Komerctransports",
  battery: "Akumulators",
  fuel: "Degvielas sistēma",
  thermometer: "Dzesēšana",
  droplets: "Eļļas maiņa",
  snowflake: "Kondicionieris",
  lightbulb: "Apgaismojums",
  radio: "Multimedijs",
  settings: "Regulēšana",
  shield: "Garantija",
  sparkles: "Detailing",
  hammer: "Remonts",
  flame: "Metināšana",
};
